import React from "react";
import { Link } from "react-router-dom";
import {
  MONEY_FUTURE_PAID_FEATURES,
  MONEY_PAID_FEATURE_DESCRIPTION,
  MONEY_PHASE1_SCOPE_NOTE,
  MONEY_STRONG_PLAN_NAME,
} from "./moneyPlanCopy";
import "./Fee.css";

/** App Store 掲載価格と利用規約の表記を揃える（変更時は Terms.tsx も更新） */
export const MONEY_PLAN_PRICES = {
  monthlyYen: 480,
  yearlyYen: 3980,
} as const;

function Fee() {
  const monthly = MONEY_PLAN_PRICES.monthlyYen;
  const yearly = MONEY_PLAN_PRICES.yearlyYen;
  const yearlyPerMonth = Math.round(yearly / 12);
  const yearlySavingsPercent = Math.round((1 - yearly / (monthly * 12)) * 100);

  return (
    <div className="MoneyFee">
      <div className="MoneyFee-inner">
        <h1>ととのう固定費の料金について</h1>
        <p className="muted">
          ととのう固定費（iOSアプリ）では、固定費の登録・集計、ローンの一覧・閲覧詳細などを無料でご利用いただけます。
          {MONEY_STRONG_PLAN_NAME}は、月間または年間の自動更新サブスクリプションです。
          {MONEY_PHASE1_SCOPE_NOTE}
        </p>

        <h2>プラン一覧（税込）</h2>
        <div className="plan-grid">
          <div className="plan-card">
            <h3>無料で使えること</h3>
            <p className="price">¥0</p>
            <p className="price-note">アカウント登録後、次の機能を利用できます。</p>
            <ul>
              <li>固定費の登録・編集・削除</li>
              <li>ダッシュボード（日/月/年の合計表示）</li>
              <li>カテゴリ別集計・12か月の推移表示</li>
              <li>支払いリマインド（端末内）</li>
              <li>ローンの一覧・閲覧詳細・基本情報の入力</li>
              <li>ローンの月次明細の表示</li>
            </ul>
          </div>

          <div className="plan-card">
            <span className="badge">おすすめ</span>
            <h3>
              {MONEY_STRONG_PLAN_NAME}（年間）
            </h3>
            <p className="price">¥{yearly.toLocaleString("ja-JP")} / 年</p>
            <p className="price-note">
              年間プラン。実質 約¥{yearlyPerMonth.toLocaleString("ja-JP")}/月（月間プラン比・約{yearlySavingsPercent}
              %お得）。1年ごとの自動更新です。
            </p>
            <ul>
              <li>{MONEY_PAID_FEATURE_DESCRIPTION}</li>
            </ul>
          </div>
        </div>

        <div className="plan-card" style={{ marginTop: 8 }}>
          <h3>{MONEY_STRONG_PLAN_NAME}（月間）</h3>
          <p className="price">¥{monthly.toLocaleString("ja-JP")} / 月</p>
          <p className="price-note">月間プラン。1か月ごとの自動更新。いつでも解約できます。</p>
          <ul>
            <li>{MONEY_PAID_FEATURE_DESCRIPTION}</li>
            <li>年間プランと同じ機能</li>
          </ul>
        </div>

        <p className="muted" style={{ marginTop: 16 }}>
          ※ 今後の追加予定（{MONEY_STRONG_PLAN_NAME}）: {MONEY_FUTURE_PAID_FEATURES}
        </p>

        <h2>お支払い・解約</h2>
        <p>
          {MONEY_STRONG_PLAN_NAME}のお支払いは Apple ID 経由の App Store 課金で行われます。開発者がクレジットカード番号等を直接取得することはありません。
          解約・プラン変更は、iPhone の「設定」→「Apple ID」→「サブスクリプション」から行えます。詳細は
          <Link to="/money/withdrawal"> サブスクリプションの解約について</Link>
          をご覧ください。
        </p>

        <h2>価格の変更</h2>
        <p>
          料金は、App Store の表示および
          <Link to="/money/terms"> 利用規約</Link>
          に従います。価格を変更する場合は、事前に本ページおよびアプリ内で周知します。
        </p>

        <p className="muted" style={{ marginTop: 24 }}>
          ※ 無料と{MONEY_STRONG_PLAN_NAME}で利用できる機能の境界は、サービス改善に伴い変更される場合があります。重要な変更は利用規約およびアプリ内でお知らせします。
        </p>
      </div>
    </div>
  );
}

export default Fee;
